import get from 'lodash.get';

const getPrivacyUrl = (rootState) =>
  get(rootState, 'user.partnerData.properties.privacyPolicyUrl', null);

export default getPrivacyUrl;
